import { createBrowserHistory } from '~/components/Router/history';


export const history = createBrowserHistory();
